import { apiInstance } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BACKOFFICE_RECIPE_QUERY_SECTION_KEY } from './get-recipe-section';

export const reorderSectionRecipe = async (
  token: string,
  id: string,
  index: number
) => {
  return apiInstance(token).patch(
    `/backoffice/recipe/section/${id}`,
    JSON.stringify({ index })
  );
};

type ReorderRecipeArgs = {
  id: string;
  destinationIndex: number;
};

export function useRecipeSectionReorderMutation() {
  const queryClient = useQueryClient();
  const token = useAuthStore((s) => s.access_token);
  return useMutation({
    mutationFn: ({ id, destinationIndex }: ReorderRecipeArgs) =>
      reorderSectionRecipe(token, id, destinationIndex),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [BACKOFFICE_RECIPE_QUERY_SECTION_KEY],
      });
    },
  });
}
